/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Coinvestments_Lpdealoverviewcontent_Choose4Inputs */

const en_coinvestments_lpdealoverviewcontent_choose4 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Choose4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Choose a ${i?.type}...`)
};

/**
* | output |
* | --- |
* | "Choose a {type}..." |
*
* @param {Coinvestments_Lpdealoverviewcontent_Choose4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_choose4 = /** @type {((inputs: Coinvestments_Lpdealoverviewcontent_Choose4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Choose4Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_choose4(inputs)
});
export { coinvestments_lpdealoverviewcontent_choose4 as "coInvestments_lpDealOverviewContent_choose" }